import styled from 'styled-components';

// Colors
import {orange} from '../../../style/colors';

const Loader = styled.div`
  width: 100%;
  padding: 20px 0px;
  text-align: center;
  color: ${orange};
  font-size: 36px;
  background: #fff5f0;
  border-radius: 8px;
  margin: 10px 0;
`;

export default Loader;
